export default __webpack_public_path__ + "static/media/about-team-yu-liu.6f469cfb.png";